/**
 * Meal Plan Builder JavaScript - UPDATED
 * Handles multi-step form, meal selection, filtering, and cart integration
 */

(function($) {
  'use strict';

  const MealPlanBuilder = {
    // Configuration
    config: {
      section: null,
      collections: {
        'type-one': '',
        'type-two': '',
        'pre-diabetes': ''
      },
      pricePerMeal: 10,
      currentStep: 1,
      totalSteps: 3
    },

    // State management
    state: {
      dietaryType: null,
      mealsCount: 10,
      deliveryDate: null,
      selectedMeals: [],
      allMeals: [],
      filteredMeals: [],
      activeFilters: []
    },

    /**
     * Initialize the meal plan builder
     */
    init: function(sectionId) {
      this.config.section = $('[data-section-id="' + sectionId + '"]');
      if (!this.config.section.length) return;

      // Get collections from section settings
      this.getCollectionSettings();

      // Initialize multi-step form
      this.initMultiStepForm();

      // Bind event listeners
      this.bindEvents();

      // Load initial state from localStorage if exists
      this.loadSavedState();
    },

    /**
     * Get collection handles from section settings
     */
    getCollectionSettings: function () {
      const section = this.config.section;

      this.config.collections['type-one'] = section.attr('data-type-one-collection') || '';
      this.config.collections['type-two'] = section.attr('data-type-two-collection') || '';
      this.config.collections['pre-diabetes'] = section.attr('data-pre-diabetes-collection') || '';
      this.config.pricePerMeal = parseFloat(section.attr('data-price-per-meal')) || 10;
      
      console.log('Collection settings loaded:', this.config.collections);
    },

    /**
     * Initialize multi-step form
     */
    initMultiStepForm: function() {
      const self = this;
      const form = $('#mrk-meal-plan-form');

      this.navigateTo = function(index) {
        const tabs = form.find('.mrk-tab');
        const steps = $('.mrk-step');

        self.config.currentStep = index + 1;

        tabs.removeClass('current').eq(index).addClass('current');

        steps.each(function(i) {
          const step = $(this);
          if (i < index) {
            step.addClass('completed').removeClass('active');
          } else if (i === index) {
            step.addClass('active').removeClass('completed');
          } else {
            step.removeClass('active completed');
          }
        });

        const progressPercent = (index / (self.config.totalSteps - 1)) * 100;
        $('.mrk-step-progress').css('width', progressPercent + '%');

        form.find('.mrk-btn-previous').toggle(index > 0);
        form.find('.mrk-btn-next').toggle(index < self.config.totalSteps - 1);
        form.find('.mrk-btn-checkout').toggle(index === self.config.totalSteps - 1);

        $('html, body').animate({ scrollTop: self.config.section.offset().top - 100 }, 300);

        if (index === 1) {
          self.loadMeals();
        } else if (index === 2) {
          self.updateCheckoutSummary();
        }

        self.saveState();
      };

      this.navigateTo(0);
    },

    /**
     * Bind all event listeners
     */
    bindEvents: function() {
      const self = this;

      // Initialize datepicker
      $('#mrk-delivery-date').datepicker({
        minDate: 0,
        maxDate: '+2M',
        dateFormat: 'DD, d MM yy',
        beforeShowDay: function (date) {
          const day = date.getDay();
          return [(day === 0), ''];
        },
        onSelect: function (dateText) { 
          self.state.deliveryDate = dateText;
          self.saveState();
        }
      });

      // Step 1: Plan selections
      $('input[name="dietary_type"]').on('change', function() {
        self.state.dietaryType = $(this).val();
        self.saveState();
      });

      $('input[name="meals_count"]').on('change', function() {
        self.state.mealsCount = parseInt($(this).val());
        self.updateMealCounter();
        self.saveState();
      });

      $('.mrk-filters-btn').on('click', function() {
        $('.mrk-filters-wrapper').addClass('active');
      });

      $('.mrk-filters-wrapper .mrk-modal-close').on('click', function() {
        $('.mrk-filters-wrapper').removeClass('active');
      });

      // Navigation buttons
      $('.mrk-btn-previous').on('click', function() {
        self.navigateTo(self.config.currentStep - 2);
      });

      $('.mrk-btn-next').on('click', function() {
        if (self.validateCurrentStep()) {
          self.navigateTo(self.config.currentStep);
        }
      });

      $('.mrk-btn-checkout').on('click', function() {
        if ($(this).prop('disabled')) return;
        self.proceedToCheckout();
      });

      // Step indicators click
      $('.mrk-step').on('click', function() {
        const stepIndex = parseInt($(this).data('step')) - 1;
        if (stepIndex < self.config.currentStep - 1) {
          self.navigateTo(stepIndex);
        }
      });

      // Carb filters
      $('input[name="carb_filter"]').on('change', function() {
        self.updateFilters();
      });

      // Meal card actions
      $(document).on('click', '.mrk-btn-add', function(e) {
        e.stopPropagation();
        const card = $(this).closest('.mrk-meal-card');
        const productId = card.data('product-id');
        self.addMeal(productId);
      });

      $(document).on('click', '.mrk-btn-remove', function(e) {
        e.stopPropagation();
        const card = $(this).closest('.mrk-meal-card');
        const productId = card.data('product-id');
        self.removeMeal(productId);
      });

      // View meal details
      $(document).on('click', '.mrk-view-details, .mrk-meal-image-wrapper, .mrk-meal-title, .m-product-card__link, .m-product-card__name', function () {
        const handle = $(this).closest('[data-product-handle]').data('product-handle');
        self.openMealModal(handle);
      });

      // Modal actions
      $('[data-modal-close]').on('click', function() {
        self.closeMealModal();
      });

      $(document).on('click', '.mrk-btn-modal-add', function() {
        const productId = $('#mrk-meal-modal').data('current-product-id');
        self.addMeal(productId);
      });

      $(document).on('click', '.mrk-btn-modal-remove', function() {
        const productId = $('#mrk-meal-modal').data('current-product-id');
        self.removeMeal(productId);
      });

      // Nutrition tab switching
      $(document).on('click', '.mrk-nutrition-tab', function () {
        const target = $(this).data('tab');
        $('.mrk-nutrition-tab').removeClass('active');
        $(this).addClass('active');
        $('.mrk-nutrition-content').removeClass('active');
        $('#' + target).addClass('active');
      });

      // Edit order button
      $('.mrk-edit-order').on('click', function() {
        self.navigateTo(1);
      });

      // Close modal on escape key
      $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('#mrk-meal-modal').is(':visible')) {
          self.closeMealModal();
        }
      });
    },

    /**
     * Validate current step before proceeding
     */
    validateCurrentStep: function() {
      const step = this.config.currentStep;

      if (step === 1) {
        if (!this.state.dietaryType) {
          alert('Please select a dietary type');
          return false;
        }
        if (!this.state.mealsCount) {
          alert('Please select meals per week');
          return false;
        }
        if (!$('#mrk-delivery-date').val()) {
          alert('Please select a delivery date');
          return false;
        }
        return true;
      }

      if (step === 2) {
        const selectedCount = this.state.selectedMeals.reduce((sum, meal) => sum + meal.quantity, 0);
        if (selectedCount < this.state.mealsCount) {
          alert('Please select ' + this.state.mealsCount + ' meals to continue');
          return false;
        }
        return true;
      }

      return true;
    },

    /**
     * Load meals based on dietary type
     */
    loadMeals: function() {
      const self = this;
      const collectionHandle = this.config.collections[this.state.dietaryType];
      
      if (!collectionHandle) {
        console.error('Collection not found for dietary type:', this.state.dietaryType);
        $('.mrk-meals-grid').html('<div class="mrk-meals-loading"><p>Collection not configured. Please set up collections in section settings.</p></div>');
        return;
      }

      $('.mrk-meals-grid').html('<div class="mrk-meals-loading"><p>Loading meals...</p></div>');

      if (this.state.dietaryType === 'type-two') {
        $('.mrk-filters-wrapper').show();
        $('.mrk-filters-btn').show();
      } else {
        $('.mrk-filters-wrapper').hide();
        $('.mrk-filters-btn').hide();
      }

      console.log('Loading products from collection:', collectionHandle);

      $.ajax({
        url: '/collections/' + collectionHandle + '?view=products-ajax',
        method: 'GET',
        dataType: 'html',
        success: function(html) {
          console.log('Products loaded successfully');
          
          if (html && html.trim().length > 0) {
            $('.mrk-meals-grid').html(html);

            self.state.allMeals = [];
            $('.mrk-meal-card').each(function() {
              const card = $(this);
              let productData = JSON.parse(card.find('[data-product-json]').html());
              self.state.allMeals.push(productData);
            });
            
            self.state.filteredMeals = self.state.allMeals;
            self.updateMealCardStates();
            self.updateMealCounter();
          } else {
            $('.mrk-meals-grid').html('<div class="mrk-meals-loading"><p>No meals found in this collection.</p></div>');
          }
        },
        error: function(xhr, status, error) {
          console.error('Error loading meals:', error);
          
          let errorMsg = 'Error loading meals. ';
          if (xhr.status === 404) {
            errorMsg += 'Collection "' + collectionHandle + '" not found. Please check collection handle in section settings.';
          } else {
            errorMsg += 'Please try again or contact support.';
          }
          
          $('.mrk-meals-grid').html('<div class="mrk-meals-loading"><p>' + errorMsg + '</p></div>');
        }
      });
    },

    /**
     * Check if product is new (created within last 60 days)
     */
    isNewProduct: function (createdAt) {
      if (!createdAt) return false;

      const created = new Date(createdAt);
      const now = new Date();
      const daysDiff = Math.floor((now - created) / (1000 * 60 * 60 * 24));

      return daysDiff <= 60;
    },

    /**
     * Update filters
     */
    updateFilters: function() {
      const self = this;
      this.state.activeFilters = [];
      
      $('input[name="carb_filter"]:checked').each(function() {
        self.state.activeFilters.push($(this).val());
      });
      
      console.log('Active filters:', this.state.activeFilters);

      if (this.state.activeFilters.length > 0) {
        $('.mrk-meal-card').each(function() {
          const card = $(this);
          const carbLevel = card.data('carb-level');

          const matches = self.state.activeFilters.some(function(filter) {
            return carbLevel && carbLevel.toLowerCase().includes(filter.toLowerCase());
          });
          
          if (matches) {
            card.show();
          } else {
            card.hide();
          }
        });

        const visibleCount = $('.mrk-meal-card:visible').length;
        console.log('Filtered meals count:', visibleCount);
        
        if (visibleCount === 0 && !$('.mrk-no-meal').length) {
          $('.mrk-meals-grid').append('<div class="mrk-meals-loading mrk-no-meal">No meals match your filters.</div>');
        } else if (visibleCount > 0 && $('.mrk-no-meal').length) {
          $('.mrk-meals-loading').remove();
        }
      } else {
        $('.mrk-meal-card').show();
        $('.mrk-meals-loading').remove();
      }
    },

    /**
     * Add meal to selection
     */
    addMeal: function(productId) {
      const currentTotal = this.state.selectedMeals.reduce((sum, meal) => sum + meal.quantity, 0);
      
      if (currentTotal >= this.state.mealsCount) {
        alert('You have already selected ' + this.state.mealsCount + ' meals');
        return;
      }
      
      const existingMeal = this.state.selectedMeals.find(m => m.id === productId);
      const product = this.state.allMeals.find(p => p.id === productId);
      
      if (!product) return;
      
      if (existingMeal) {
        existingMeal.quantity++;
      } else {
        this.state.selectedMeals.push({
          id: productId,
          title: product.title,
          handle: product.handle,
          image: product.image ? product.image : null,
          price: product.variants[0].price,
          quantity: 1
        });
      }
      
      this.updateMealCardStates();
      this.updateMealCounter();
      this.saveState();
    },

    /**
     * Remove meal from selection
     */
    removeMeal: function(productId) {
      const existingMeal = this.state.selectedMeals.find(m => m.id === productId);
      
      if (!existingMeal) return;
      
      if (existingMeal.quantity > 1) {
        existingMeal.quantity--;
      } else {
        this.state.selectedMeals = this.state.selectedMeals.filter(m => m.id !== productId);
      }
      
      this.updateMealCardStates();
      this.updateMealCounter();
      this.saveState();
    },

    /**
     * Update meal card visual states
     */
    updateMealCardStates: function() {
      const self = this;
      
      $('.mrk-meal-card').each(function() {
        const card = $(this);
        const productId = card.data('product-id');
        const selectedMeal = self.state.selectedMeals.find(m => m.id === productId);
        const quantity = selectedMeal ? selectedMeal.quantity : 0;
        
        if (quantity > 0) {
          card.addClass('selected');
        } else {
          card.removeClass('selected');
        }
        $(card).find('.mrk-current-selected-count').text(quantity);
      });
    },

    /**
     * Update meal counter display
     */
    updateMealCounter: function() {
      const selectedCount = this.state.selectedMeals.reduce((sum, meal) => sum + meal.quantity, 0);
      const remaining = this.state.mealsCount - selectedCount;
      const progress = (selectedCount / this.state.mealsCount) * 100;
      
      $('.mrk-selected-count').text(selectedCount);
      $('.mrk-total-count').text(this.state.mealsCount);
      $('.mrk-remaining-count').text(remaining);
      $('.mrk-progress-fill').css('width', progress + '%');

      if (selectedCount === this.state.mealsCount) {
        $('.mrk-counter-message').html('<strong style="color: rgb(var(--color-success));">Ready to proceed!</strong>');
        $('html, body').animate({
            scrollTop: $('.mrk-meal-counter-sticky').offset().top - 100
        }, 800);
      } else if (remaining > 0) {
        $('.mrk-counter-message').html('Select <strong class="mrk-remaining-count">' + remaining + '</strong> more meal' + (remaining > 1 ? 's' : '') + ' to continue.');
      }

      if (this.config.currentStep === 2) {
        $('.mrk-btn-checkout').prop('disabled', selectedCount < this.state.mealsCount);
      }
    },

    /**
     * Open meal detail modal
     */
    openMealModal: function(handle) {
      const self = this;

      const product = this.state.allMeals.find(p => p.handle === handle);
      
      if (product) {
        self.populateMealModal(product);
        $('#mrk-meal-modal').data('current-product-id', product.id).fadeIn(300);
        $('body').css('overflow', 'hidden');
      } else {
        $.ajax({
          url: '/products/' + handle + '?view=product-json',
          method: 'GET',
          dataType: 'json',
          success: function(productData) {
            self.populateMealModal(productData);
            $('#mrk-meal-modal').data('current-product-id', productData.id).fadeIn(300);
            $('body').css('overflow', 'hidden');
          },
          error: function(xhr, status, error) {
            console.error('Error loading product:', error);
            alert('Unable to load meal details. Please try again.');
          }
        });
      }
    },

    /**
     * Populate modal with meal data
     */
    populateMealModal: function(product) {
      const modal = $('#mrk-meal-modal');
      const metafields = product.metafields.custom || {};
      
      // Update image
      if (product.featured_image && product.featured_image.src) {
        modal.find('[data-modal-image]').attr('src', product.featured_image.src).attr('alt', product.title);
      } else if (product.images && product.images.length > 0 && product.images[0].src) {
        modal.find('[data-modal-image]').attr('src', product.images[0].src).attr('alt', product.title);
      }
      
      // Update title
      modal.find('[data-modal-title]').text(product.title);
      
      // Update description
      const description = product.description || '';
      modal.find('[data-modal-description]').html(description);
      
      // Update nutritional highlights
      const calories = metafields.calories_per_serving || '-';
      const protein = metafields.protein_per_serving || '-';
      const carbs = metafields.carbs_per_serving || '-';
      const fats = metafields.fat_per_serving || '-';
      const portionSize = metafields.portion_size || '-';
      
      modal.find('[data-value="portion"]').text(portionSize);
      modal.find('[data-value="calories"]').text(calories?.split(' ')[0]);
      modal.find('[data-value="protein"]').text(protein);
      modal.find('[data-value="carbs"]').text(carbs);
      modal.find('[data-value="fats"]').text(fats);
      
      // Update ingredients
      const ingredients = metafields.ingredients_list || [];
      if (Array.isArray(ingredients) && ingredients.length > 0) {
        modal.find('[data-modal-ingredients]').html(ingredients.join(', '));
      } else {
        modal.find('[data-modal-ingredients]').text('Not available');
      }
      
      // Update allergens
      const allergens = metafields.allergen_information || [];
      if (Array.isArray(allergens) && allergens.length > 0) {
        modal.find('[data-modal-allergens]').text(allergens.join(', '));
      } else {
        modal.find('[data-modal-allergens]').text('None');
      }
      
      // Update nutrition table (per serving)
      modal.find('[data-serving="calories"]').text(calories);
      modal.find('[data-serving="fat"]').text(metafields.fat_per_serving || '-');
      modal.find('[data-serving="energy-kj"]').text(metafields.energy_kj_per_serving || '-');
      modal.find('[data-serving="saturates"]').text(metafields.saturates_per_serving || '-');
      modal.find('[data-serving="carbs"]').text(carbs);
      modal.find('[data-serving="sugars"]').text(metafields.sugars_per_serving || '-');
      modal.find('[data-serving="fibre"]').text(metafields.fibre_per_serving || '-');
      modal.find('[data-serving="protein"]').text(protein);
      modal.find('[data-serving="salt"]').text(metafields.salt_per_serving || '-');
      
      // Update nutrition table (per 100g)
      modal.find('[data-per100="calories"]').text(metafields.calories_per_100g || '-');
      modal.find('[data-per100="energy-kj"]').text(metafields.energy_kj_per_100g || '-');
      modal.find('[data-per100="calories"]').text(metafields.calories_per_100g || '-');
      modal.find('[data-per100="fat"]').text(metafields.fat_per_100g || '-');
      modal.find('[data-per100="saturates"]').text(metafields.saturates_per_100g || '-');
      modal.find('[data-per100="carbs"]').text(metafields.carbs_per_100g || '-');
      modal.find('[data-per100="sugars"]').text(metafields.sugars_per_100g || '-');
      modal.find('[data-per100="fibre"]').text(metafields.fibre_per_100g || '-');
      modal.find('[data-per100="protein"]').text(metafields.protein_per_100g || '-');
      modal.find('[data-per100="salt"]').text(metafields.salt_per_100g || '-');
      
      // Update badges
      const badges = modal.find('[data-modal-badges]');
      badges.empty();
      
      // Check if product is new (within 60 days)
      if (product.created_at && this.isNewProduct(product.created_at)) {
        badges.append('<span class="mrk-badge mrk-badge-new">New</span>');
      }

      // Under 600 calories badge
      if (calories && parseInt(calories) < 600) {
        badges.append('<span class="mrk-badge mrk-badge-under-600">Under 600kcals</span>');
      }

      const isVegetarian = metafields.vegetarian === true || metafields.vegetarian === 'true';
      if (isVegetarian) {
        badges.append('<span class="mrk-badge mrk-badge-vegetarian">Vegetarian</span>');
      }
      
      const carbLevel = metafields.carb_level;
      if (carbLevel) {
        const carbClass = carbLevel.toLowerCase().replace(/\s/g, '-');
        badges.append('<span class="mrk-badge mrk-badge-carb mrk-badge-' + carbClass + '">' + carbLevel + '</span>');
      }
    },

    /**
     * Close meal modal
     */
    closeMealModal: function() {
      $('#mrk-meal-modal').fadeOut(300);
      $('body').css('overflow', '');
    },

    /**
     * Update checkout summary
     */
    updateCheckoutSummary: function () {
      const dietaryTypeMap = {
        'type-one': 'Type One Diabetes',
        'type-two': 'Type Two Diabetes',
        'pre-diabetes': 'Pre Diabetes'
      };
      
      $('[data-summary="dietary-type"]').text(dietaryTypeMap[this.state.dietaryType] || '-');
      $('[data-summary="meals-count"]').text(this.state.mealsCount + ' meals');
      $('[data-summary="delivery-date"]').text(this.state.deliveryDate || '-');

      const mealsList = $('[data-summary-meals]');
      mealsList.empty();
      
      this.state.selectedMeals.forEach(function(meal) {
        const item = $('<div class="mrk-summary-meal-item">');
        item.append('<span class="mrk-summary-meal-qty">' + meal.quantity + 'x</span>');
        item.append('<span class="mrk-summary-meal-name">' + meal.title + '</span>');
        mealsList.append(item);
      });
      const sum = 0;
      console.log(this.state.selectedMeals);
      const subtotal = this.state.selectedMeals.reduce((sum, meal) => sum + (Number(meal.price) * Number(meal.quantity)), 0);
      const total = subtotal;
      
      $('[data-summary="subtotal"]').text(formatMoney(subtotal));
      $('[data-summary="total"]').text(formatMoney(total));
    },

    /**
     * Proceed to Shopify checkout
     */
    proceedToCheckout: function() {
      const self = this;

      const email = $('#customer-email').val();
      if (!email) {
        alert('Please enter your email address');
        return;
      }
      
      const cartNote = $('#cart-note').val();

      const items = [];
      this.state.selectedMeals.forEach(function(meal) {
        const product = self.state.allMeals.find(p => p.id === meal.id);
        if (product && product.variants && product.variants.length > 0) {
          items.push({
            id: product.variants[0].id,
            quantity: meal.quantity,
            properties: {
              'Dietary Type': self.state.dietaryType,
              'Delivery Date': self.state.deliveryDate
            }
          });
        }
      });

      $.ajax({
        url: '/cart/add.js',
        method: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        success: function () {
          $.ajax({
            url: '/cart/update.js',
            method: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
              note: cartNote,
              attributes: {
                'Customer Email': email,
                'Dietary Type': self.state.dietaryType,
                'Delivery Date': self.state.deliveryDate,
                'Meal Plan Size': self.state.mealsCount
              }
            }),
            success: function () {
              self.clearState();
              window.location.href = '/checkout';
            },
            error: function(xhr, status, error) {
              console.error('Error updating cart:', error);
              alert('Unable to update cart. Please try again.');
            }
          });
        },
        error: function(xhr, status, error) {
          console.error('Error adding to cart:', error);
          alert('Unable to add meals to cart. Please try again.');
        }
      });
    },

    /**
     * Save state to localStorage
     */
    saveState: function() {
      try {
        localStorage.setItem('mealPlanState', JSON.stringify(this.state));
      } catch(e) {
        console.error('Error saving state:', e);
      }
    },

    /**
     * Load saved state from localStorage
     */
    loadSavedState: function() {
      try {
        const saved = localStorage.getItem('mealPlanState');
        if (saved) {
          const state = JSON.parse(saved);

          if (state.dietaryType) {
            this.state.dietaryType = state.dietaryType;
            $('input[name="dietary_type"][value="' + state.dietaryType + '"]').prop('checked', true);
          }
          
          if (state.mealsCount) {
            this.state.mealsCount = state.mealsCount;
            $('input[name="meals_count"][value="' + state.mealsCount + '"]').prop('checked', true);
          }
          
          if (state.deliveryDate) {
            this.state.deliveryDate = state.deliveryDate;
            $('select[name="delivery_date"]').val(state.deliveryDate);
          }
          
          if (state.selectedMeals) {
            this.state.selectedMeals = state.selectedMeals;
          }
        }
      } catch(e) {
        console.error('Error loading state:', e);
      }
    },

    /**
     * Clear saved state
     */
    clearState: function() {
      try {
        localStorage.removeItem('mealPlanState');
      } catch(e) {
        console.error('Error clearing state:', e);
      }
    }
  };

  // Initialize when document is ready
  $(document).ready(function () {
    const sectionId = $('.mrk-meal-plan-builder').data('section-id');
    if (sectionId) {
      MealPlanBuilder.init(sectionId);
    }
  });

})(jQuery);